import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ColumnApi } from 'ag-grid-community';
import { PolizaService } from 'app/main/captura/poliza/services/poliza.service';
import { Permiso } from 'app/main/utilerias/models/usuarios/permiso';
import { agGridPolizasBusquedaDefs } from 'app/shared/models/contratantes-defs';
import { AuthService } from 'app/shared/services/auth.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-busqueda-polizas',
  templateUrl: './busqueda-polizas.component.html',
  styleUrls: ['./busqueda-polizas.component.css']
})
export class  BusquedaPolizasComponent implements OnInit {

  title: string;
  message: string;
  permisos: Permiso;
  origen: string;

  private gridApi;
  private gridColumnApi: ColumnApi;
  @BlockUI('listadoPolizas') blockUI: NgBlockUI;

  defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true
  };

  rowData: any[] = [];
  columnDefs = agGridPolizasBusquedaDefs;

  constructor(private dialogRef: MatDialogRef<BusquedaPolizasComponent>, @Inject(MAT_DIALOG_DATA) data,
    private authService: AuthService, private fb: FormBuilder, private polizasService: PolizaService) {
    this.title = data.title;
    this.message = data.message;
    this.origen = data.origen ? data.origen : null;

    this.permisos = this.authService.obtenerPermisoPorOpcion('Usuarios');
  }

  ngOnInit(): void {
    this.blockUI.start('Realizando busqueda...');
    if (this.origen === 'siniestros') {
      this.polizasService.obtenerPolizasBusquedaNoCanceladas().subscribe((polizas: any) => {
        this.rowData = polizas;
        this.gridColumnApi.autoSizeAllColumns();
        this.blockUI.stop();
      });
    } else {
      this.polizasService.obtenerPolizasBusqueda().subscribe((polizas: any) => {
        this.rowData = polizas;
        this.gridColumnApi.autoSizeAllColumns();
        this.blockUI.stop();
      });
    }
  }

  /**
   * Al cancelar la operacion enviamos false para que no se realice ninguna accion.
   */
  cancelar(): void {
    this.dialogRef.close(false);
  }

  onRowDoubleClick(fila) {
    this.dialogRef.close(fila.data);
  }

  /**
  * Se ejecuta este metodo cuando el grid esta renderizado y re ajusta el tamaño de las celdas cuando se cambia de tamaño la pantalla.
  * @param params grid framework object
  */
  onGridReady(params): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    // tslint:disable-next-line:typedef
    window.addEventListener('resize', () => {
      // tslint:disable-next-line:typedef
      setTimeout(() => {
        this.gridColumnApi.autoSizeAllColumns();
      });
    });
  }



}
